"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPaypalOrder = void 0;
const checkout_frontend_library_1 = require("@bold-commerce/checkout-frontend-library");
const src_1 = require("..");
function getPaypalOrder() {
    const publicOrderId = (0, checkout_frontend_library_1.getPublicOrderId)();
    return {
        purchase_units: [{
                custom_id: publicOrderId,
                amount: (0, src_1.getPaypalAmountWithBreakdown)(),
                items: (0, src_1.getPaypalPurchaseItems)()
            }]
    };
}
exports.getPaypalOrder = getPaypalOrder;
